import styled from 'styled-components';
import { Calendar as LucideCalendar, ChevronDown } from 'lucide-react';
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
} from 'components/dropdown/dropdown';
import { Button as BaseButton } from 'components';

export const DateRangeButton = styled(BaseButton).attrs({
  variant: 'outline',
  className: 'h-10 px-3 py-2 text-sm flex gap-2 items-center bg-white justify-between min-w-45',
})``;

export const DateRangeButtonContent = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

export const CalendarIcon = styled(LucideCalendar).attrs({
  className: 'h-4 w-4',
})``;

export const ChevronDownIcon = styled(ChevronDown).attrs({
  className: 'h-4 w-4 opacity-50',
})``;

export const TimeRangeDropdownContent = styled(DropdownMenuContent).attrs({
  align: 'start',
  className: 'w-auto min-w-45 p-0',
})``;

export const TimeRangeDropdownGroup = styled.div.attrs({
  className: 'p-1',
})``;

export const TimeRangeDropdownItem = styled(DropdownMenuItem).attrs<{
  $isSelected?: boolean;
}>(({ $isSelected }) => ({
  className: `flex flex-row items-center h-8 px-1.5 py-1 gap-1.5 isolate w-full rounded-lg flex-none order-0 self-stretch flex-grow-0 cursor-pointer ${
    $isSelected ? 'bg-[rgba(84,110,180,0.1)]' : ''
  }`,
}))<{ $isSelected?: boolean }>``;

export const DropdownItemText = styled.span.attrs({
  className:
    'flex-1 text-sm font-medium leading-5 text-gray-950 font-["Lato"] z-[1] overflow-hidden text-ellipsis whitespace-nowrap',
})``;

export const DropdownItemCheckWrapper = styled.div.attrs({
  className: 'flex-none w-4 h-4 flex items-center justify-center z-[2]',
})``;

export const CustomRangeContainer = styled.div.attrs({
  className: 'flex flex-col',
})``;

export const CustomRangeLabel = styled(DropdownMenuLabel).attrs({
  className: 'font-normal text-muted-foreground px-3 py-1.5 text-xs tracking-wider',
})``;

export const CalendarWrapper = styled.div.attrs({
  className: 'px-1 pb-1 bg-white rounded-b-md [&_[data-slot=calendar]]:bg-white',
})``;
